import moment from 'moment'
import { ATTRIBUTE_TYPE } from 'ifield-core-components'
import { ACTIVITY_CODE, ACCURACY_RATING_CODE } from '@/constants'

/**
 * 文字列値のソート比較関数
 * @param {string} a 値A
 * @param {string} b 値B
 * @returns {number}
 */
export const compareString = (a, b) => {
  const sA = `${a || ''}`
  const sB = `${b || ''}`
  if (sA == sB) return 0
  return sA > sB ? 1 : -1
}

/**
 * 数値のソート比較関数
 * @param {string} a 値A
 * @param {string} b 値B
 * @returns {number}
 */
export const compareNumber = (a, b) => {
  if (a == null) return 1
  if (b == null) return -1
  return a - b
}

/**
 * 日付/日時のソート比較関数
 * @param {string|Date} a 値A
 * @param {string|Date} b 値B
 * @returns {number}
 */
export const compareDatetime = (a, b) => {
  const mA = moment(a)
  const mB = moment(b)
  if (!mA.isValid()) return 1
  if (!mB.isValid()) return -1
  return mA - mB
}

/**
 * ヒエラルキーに応じたソート比較関数
 * @param {*} a 値A
 * @param {*} b 値B
 * @param {*[]} hierarchy ヒエラルキー(昇順時に前にするアイテムを前に配置する)
 * @returns {number}
 */
export const compareHierarchy = (a, b, hierarchy) => {
  const indexA = hierarchy.findIndex((item) => item === a)
  const indexB = hierarchy.findIndex((item) => item === b)
  return indexA - indexB
}

/**
 * 権限のソート比較関数
 * @param {Object} a 値A
 * @param {Object} b 値B
 * @returns {number}
 */
export const compareRole = (a, b) => {
  // 権限のヒエラルキー(強いほうが後ろ)
  const HIERARCHY = ['ROLE_USER', 'ROLE_ADMINISTRATOR']
  return compareHierarchy(a, b, HIERARCHY)
}

/**
 * 測位の正確性評価のソート比較関数
 * @param {Object} a 値A
 * @param {Object} b 値B
 * @returns {number}
 */
export const compareAccuracyRating = (a, b) => {
  // 評価のヒエラルキー(強いほうが後ろ)
  const HIERARCHY = [
    ACCURACY_RATING_CODE.OUT_OF_SCOPE,
    ACCURACY_RATING_CODE.LOW,
    ACCURACY_RATING_CODE.MIDDLE,
    ACCURACY_RATING_CODE.HIGH,
  ]
  return compareHierarchy(a, b, HIERARCHY)
}

/**
 * 稼働状態評価のソート比較関数
 * STILL以外 > STILL > 空 の順のヒエラルキーでソート
 * @param {string} a 値A
 * @param {string} b 値B
 * @returns {number}
 */
export const compareActivity = (a, b) => {
  const codes = Object.values(ACTIVITY_CODE)
  const getIndex = (code) =>
    codes.includes(code) ? +(code !== ACTIVITY_CODE.STILL) : -1

  return getIndex(a) - getIndex(b)
}

/**
 * ユーザー属性のソート比較関数
 */
export const attributeComparator = {
  [ATTRIBUTE_TYPE.STRING]: compareString,
  [ATTRIBUTE_TYPE.NUMBER]: compareNumber,
  [ATTRIBUTE_TYPE.SINGLE_SELECT]: compareString,
  [ATTRIBUTE_TYPE.DATE]: compareDatetime,
  [ATTRIBUTE_TYPE.DATETIME]: compareDatetime,
  [ATTRIBUTE_TYPE.CHECK]: compareString,
  [ATTRIBUTE_TYPE.TOGGLE]: compareString,
  [ATTRIBUTE_TYPE.LABEL]: compareString,
  [ATTRIBUTE_TYPE.LINK]: compareString,
}
